export const ERROR = {
    PAYMENT_OPTION_UNAVAILABLE: 'PAYMENT_OPTION_UNAVAILABLE',
    HOMECREDIT_ACCOUNT_UNAVAILABLE: 'HOMECREDIT_ACCOUNT_UNAVAILABLE',
    TECHNICAL_PROBLEM: 'TECHNICAL_PROBLEM'
}